import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import ReadyToGradeModal from "./ReadyToGradeModal";

const NavbarMHE = ({
	trainerID,
	onSignOut,
	isAdmin,
	isManager,
	isTrainer = false,
	isGrader,
	accessToken,
	profilePicture,
	userDisplayName,
}) => {
	const navigate = useNavigate();
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const [localProfilePicture, setLocalProfilePicture] =
		useState(profilePicture);
	const [localUserDisplayName, setLocalUserDisplayName] =
		useState(userDisplayName);
	const [readyList, setReadyList] = useState([]);
	const [showReadyModal, setShowReadyModal] = useState(false);

	const canSeeAlert = isAdmin || isManager || isTrainer;

	useEffect(() => {
		const img = sessionStorage.getItem("profilePicture");
		const name = sessionStorage.getItem("userDisplayName");
		if (img) setLocalProfilePicture(img);
		if (name) setLocalUserDisplayName(name);
	}, []);

	const handleSignOut = () => {
		onSignOut?.();
		navigate("/");
	};

	const toggleDropdown = () => setIsDropdownOpen((o) => !o);

	const getInitials = (email = "") => {
		const parts = email.split("@")[0].split(".");
		return parts
			.map((p) => p[0]?.toUpperCase() || "")
			.join("")
			.slice(0, 2);
	};

	return (
		<>
			<nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-navbar">
				<NavLink className="navbar-brand mx-3 mb-2" to="/">
					<img
						src="/images/cw-services.png"
						alt="CW Services Logo"
						style={{ width: "135px", height: "80px" }}
					/>
				</NavLink>

				<ul className="navbar-nav ml-auto">
					<li className="nav-item">
						<NavLink className="nav-link" to="/">
							Home
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink className="nav-link" to="/mhe-home">
							MHE Dashboard
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink className="nav-link" to="/competency-matrix">
							Competency Matrix
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink className="nav-link" to="/sop-documents">
							Resources
						</NavLink>
					</li>
				</ul>

				<div className="ml-auto d-flex align-items-center position-relative">
					{trainerID ? (
						<>
							<div
								style={{ position: "relative", cursor: "pointer" }}
								onClick={toggleDropdown}
							>
								{localProfilePicture ? (
									<img
										src={localProfilePicture}
										alt="Profile"
										style={{ width: 60, height: 60, borderRadius: "50%" }}
									/>
								) : (
									<div
										style={{
											width: 60,
											height: 60,
											borderRadius: "50%",
											backgroundColor: "#65758A",
											color: "white",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											fontSize: 20,
											fontWeight: "bold",
										}}
									>
										{getInitials(trainerID)}
									</div>
								)}

								{canSeeAlert && readyList.length > 0 && (
									<span className="ready-dot" />
								)}
							</div>

							{isDropdownOpen && (
								<div
									className="custom-dropdown-menu"
									style={{
										position: "absolute",
										top: 70,
										right: 0,
										backgroundColor: "#444",
										borderRadius: 8,
										padding: 20,
										zIndex: 1000,
										minWidth: 300,
									}}
								>
									<div className="d-flex align-items-center mb-3">
										{localProfilePicture ? (
											<img
												src={localProfilePicture}
												alt="Profile"
												style={{
													width: 80,
													height: 80,
													borderRadius: "50%",
													marginRight: 15,
												}}
											/>
										) : (
											<div
												style={{
													width: 80,
													height: 80,
													borderRadius: "50%",
													backgroundColor: "#65758A",
													color: "#fff",
													display: "flex",
													alignItems: "center",
													justifyContent: "center",
													fontSize: 30,
													fontWeight: "bold",
													marginRight: 15,
												}}
											>
												{getInitials(trainerID)}
											</div>
										)}
										<div>
											<p
												style={{
													margin: 0,
													fontSize: 18,
													fontWeight: "bold",
													color: "#fff",
												}}
											>
												{localUserDisplayName || "User"}
											</p>
											<p style={{ margin: 0, fontSize: 12, color: "#eee" }}>
												{trainerID}
											</p>
										</div>
									</div>

									<hr style={{ borderColor: "#666" }} />

									<div className="d-flex flex-column">
										{isAdmin && (
											<NavLink
												className="dropdown-button mb-1"
												to="/admin-dashboard"
												onClick={toggleDropdown}
											>
												Admin Dashboard
											</NavLink>
										)}
										{(isAdmin || isGrader) && (
											<NavLink
												className="dropdown-button mb-1"
												to="/grader-admin-dashboard"
												onClick={toggleDropdown}
											>
												Grader Dashboard
											</NavLink>
										)}
										<Button variant="danger" onClick={handleSignOut}>
											Sign Out
										</Button>
									</div>
								</div>
							)}
						</>
					) : (
						<NavLink className="btn btn-outline-primary" to="/login">
							Sign In
						</NavLink>
					)}
				</div>
			</nav>

			<ReadyToGradeModal
				show={canSeeAlert && showReadyModal}
				onClose={() => setShowReadyModal(false)}
				data={readyList}
			/>

		</>
	);
};

export default NavbarMHE;
